import {ProductPriceMapping} from "../../common/models/StoreProductPrice";
import {IvStoreProduct} from "./IvStoreProduct";

export const ProductPrices: ProductPriceMapping<IvStoreProduct> = {
    PRO: 149,
    BACKTESTING: 99,
    TRADING_SYSTEMS: 149,
    BUNDLE: 299
};
